<template>
    <div class="content-page">
        <div class="bd">
            <div class="tab-content">
                <div class="list">
                    <ul v-if="messageList.length">
                        <li class="message-item" v-for="(item,index) in messageList" :key="index" @click="linkTo(`/message/info?newsId=${item.newsId}`)">
                            <p class="title">
                                <i class="read-type" v-if="!item.isRead"></i>
                                {{item.newsTitle}}
                            </p>
                            <p class="create-time">{{item.createTime}}</p>
                            <p class="content"></p>
                        </li>
                    </ul>
                    <div v-else>
                        <div class="list-none">
                            <p>暂无更多信息</p>
                        </div>
                    </div>
                    <el-pagination
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-size="pageSize"
                        background
                        layout="prev, pager, next, jumper"
                        :total="messageList.length"
                    ></el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";
export default {
    data() {
        return {
            pageSize: 5
        };
    },
    computed: {
        ...mapState({
            messageList: state => state.messageList,
        })
    },
    mounted() {
    },
    methods: {
        handleSizeChange() {},
        handleCurrentChange() {},
        linkTo(path) {
            this.$router.push({
                path: path
            });
        }
    }
};
</script>

<style lang="less" scoped>
.content-page {
    .list {
        width: 100%;
        // padding: 0 20px;
        .message-item {
            cursor: pointer;
            margin: 0 20px 31px;
            border-bottom: 1px solid #dfe5e7;
            .title {
                font-size: 16px;
                line-height: 16px;
                color: #333333;
                margin-top: 24px;
                position: relative;
                .read-type {
                    position: absolute;
                    display: inline-block;
                    width: 8px;
                    height: 8px;
                    background: #ff0000;
                    border-radius: 50%;
                    left: -10px;
                    top: 50%;
                    transform: translateY(-50%);
                }
            }
            .create-time,
            .content {
                font-size: 12px;
                line-height: 12px;
                color: #999999;
            }
            .create-time {
                margin-top: 10px;
            }
            .content {
                margin-top: 20px;
                margin-bottom: 31px;
            }
        }
        .list-none {
            text-align: center;
            font-size: 14px;
            color: #999999;
            padding-top: 100px;
            & > p {
                margin: 10px 0;
            }
        }
    }
    .el-pagination {
        margin-left: 20px;
    }
}
</style>

